const normalizeApiBaseUrl = (url) => {
  const configured = String(url || '').trim().replace(/\/+$/, '')
  if (!configured) {
    return 'https://digitalhugs.in/api/'
  }

  return /\/api$/i.test(configured) ? `${configured}/` : `${configured}/api/`
}

export const API_BASE_URL = normalizeApiBaseUrl(process.env.REACT_APP_API_BASE_URL)

export const API_ENDPOINTS = {
  auth: {
    login: 'auth/login.html',
    data: 'auth/data.html',
    refreshToken: 'auth/refresh-token.html',
    requestPasswordReset: 'auth/request-password-reset.html',
    resetPassword: 'auth/reset-password.html',
    updateProfile: ['auth/update-profile.html'],
  },
  common: {
    photoshootTypes: 'common/photoshoot-types.html',
    photoshootType: 'common/photoshoot-type.html',
    appDownloads: 'common/app-downloads.html',
  },
  leads: {
    index: 'leads/index.html',
    create: ['leads/create.html'],
    update: ['leads/update.html', 'leads/edit.html', 'leads/update-lead.html'],
    createFollowup: ['leads/create-followup.html'],
    followups: 'leads/followups.html',
    important: ['leads/important.html'],
    delete: ['lead/delete.html', 'leads/delete.html', 'leads/remove.html'],
    duplicate: ['leads/duplicate.html'],
  },
  office: {
    get: 'office/get.html',
    update: 'office/update.html',
    countries: 'office/countries.html',
    states: 'office/states.html',
    cities: 'office/cities.html',
  },
  quotation: {
    index: 'quotation/index.html',
    create: ['quotation/create.html'],
    update: ['quotation/update.html'],
    view: 'quotation/view.html',
    viewPdf: 'quotation/view-pdf.html',
    confirmQuotation: ['quotation/confirm-quotation.html'],
    getNotes: 'quotation/get-notes.html',
    saveNotes: ['quotation/save-notes.html'],
    extrasIndex: 'quotation/extras-index.html',
    extrasCreate: ['quotation/extras-create.html'],
    extrasUpdate: ['quotation/extras-update.html'],
    extrasDelete: ['quotation/extras-delete.html'],
    addPayment: ['quotation/add-payment.html'],
    updatePayment: ['quotation/update-payment.html'],
    deletePayment: ['quotation/delete-payment.html'],
    delete: ['quotation/delete.html'],
    defaults: 'quotation/defaults.html',
    updateDefaults: ['quotation/update-quotation-defaults.html'],
    templates: 'quotation/quotation-templates.html',
    quoteTheme: 'quotation/quote-theme.html',
    updateQuoteTheme: ['quotation/update-quote-theme.html'],
    createTemplate: ['quotation/create-template.html'],
    updateTemplate: ['quotation/update-template.html'],
    eventServiceTypes: 'quotation/event-service-types.html',
    officeEventServices: ['quotation/office-event-services.html', 'quotation/event-service-types.html'],
    createEventService: [
      'common/create-event-service',
      'quotation/create-event-service-type.html',
      'quotation/add-event-service-type.html',
      'quotation/create-event-service.html',
    ],
    updateEventService: [
      'common/update-event-service',
      'quotation/update-event-service-type.html',
      'quotation/edit-event-service-type.html',
      'quotation/update-event-service.html',
    ],
    approveEventSession: ['quotation/approve-event-session.html'],
    updateEventSessions: ['quotation/update-event-sessions.html'],
    focusPersons: ['quotation/admin-focus-persons.html'],
    addFocusPerson: ['quotation/admin-add-focus-person.html'],
    deleteFocusPerson: ['quotation/admin-delete-focus-person.html'],
  },
  work: {
    index: 'work/index.html',
    workReport: 'work/work-report.html',
    financialReport: 'work/financial-report-summary.html',
    calendar: 'work/calendar.html',
    confirmedWorks: 'work/confirmed-works.html',
    requiredFootages: 'work/required-footage.html',
    view: 'work/view.html',
    professionalCategories: 'work/professional-categories.html',
    professionals: 'work/professionals.html',
    addCrew: ['work/add-crew.html'],
    changeCrewEvent: ['work/change-crew-event.html'],
    sendMessage: ['work/send-message.html'],
    saveFootageNote: ['work/save-footage-note.html'],
    removeCrew: ['work/remove-crew.html'],
    setEventPriority: ['work/set-event-priority.html'],
    updateWhatsappGroupLink: ['work/update-whatsapp-group-link.html'],
    expenseCategories: 'work/expense-categories.html',
    saveExpense: ['work/save-expense.html'],
    updateExpense: ['work/update-expense.html'],
    deleteExpense: ['work/delete-expense.html'],
    createTask: ['work/create-task.html'],
    updateTask: ['work/update-task.html'],
    deleteTask: ['work/delete-task.html'],
    addContact: ['work/add-contact.html'],
    updateContact: ['work/update-contact.html'],
    deleteContact: ['work/delete-contact.html'],
    importTasks: ['work/import-tasks.html'],
    myTasks: 'work/my-tasks.html',
    allTasks: 'work/all-tasks.html',
    updateTaskAssignmentStatus: ['work/update-task-assignment-status.html'],
  },
  officeExpense: {
    categories: 'office-expense/categories.html',
    summary: 'office-expense/summary.html',
    index: 'office-expense/index.html',
    create: 'office-expense/create.html',
    update: 'office-expense/update.html',
    delete: 'office-expense/delete.html',
    recurringIndex: 'office-expense-recurring/index.html',
    recurringView: 'office-expense-recurring/view.html',
    recurringCreate: 'office-expense-recurring/create.html',
    recurringUpdate: 'office-expense-recurring/update.html',
    recurringDelete: 'office-expense-recurring/delete.html',
    recurringPause: 'office-expense-recurring/pause.html',
    recurringResume: 'office-expense-recurring/resume.html',
  },
  crew: {
    index: 'crew/index.html',
    categories: 'crew/categories.html',
    create: 'crew/create.html',
    update: 'crew/update.html',
    assignedDates: 'crew/assigned-dates.html',
    myAssignments: 'crew/my-assignments.html',
    signupInfo: 'crew/signup-info.html',
    signup: 'crew/signup.html',
  },
  staff: {
    index: 'staff/index.html',
    create: 'staff/create.html',
    update: 'staff/update.html',
    checkUsername: 'staff/check-username.html',
  },
  staffPermissions: {
    index: 'staff-permissions/index.html',
    save: ['staff-permissions/save.html'],
  },
  workflow: {
    completeWork: ['quotation/complete-work.html'],
  },
  invoices: {
    index: 'invoice/index.html',
    view: 'invoice/view.html',
    download: 'invoice/download.html',
    initiate: ['payment/initiate.html'],
    verifyRazorpay: ['payment/verify-razorpay.html'],
  },
}

export const buildApiUrl = (path) => `${API_BASE_URL}${String(path || '').replace(/^\/+/, '')}`
